/* FILTER AND SORTING */
export const CHANGE_FILTER = "CHANGE_FILTER";
export const CHANGE_SORT = "CHANGE_SORT"